module.exports = __webpack_public_path__ + "static/kpj-42a541f34ac46291c3837bf665d47bed.png";